import { Utils } from './../../helper/utils';
import { userBALService } from '../user.bal';
const {config} = require('../../config');

const True = true;

const getColumnList = async (params) => {
    return  {
        'SnPRatingMap': 
                {'AAA': 1, 'AA+': 2, 'AA': 3, 'AA-': 4, 'A+': 5, 'A': 6, 'A-': 7, 'BBB+': 8, 'BBB': 9, 'BBB-': 10, 'BB+': 11, 'BB': 12, 'BB-': 13, 'B+': 14, 'B': 15, 'B-': 16, 'CCC+': 17, 'CCC': 18, 'CCC-': 19, 'CC': 20, 'C': 21, 'D': 22}, 
        'columnSpecs': [
            {'display': 'Period', 'col': 'Period', 'agg': 'uniq', 'ag-grid': True, 'hide': true, 'rowGroup': true, minWidth: 86},
            {'display': 'Total', 'col': 'Total', 'agg': 'uniq', 'format': 'percentFormat2P', 'ag-grid': True, 'pnl-grid': True, minWidth: 78, flex: 1},
            {'display': 'Public', 'col': 'Public', 'agg': 'uniq', 'format': 'percentFormat2P', 'ag-grid': True, 'pnl-grid': True, minWidth: 78, flex: 1},
            {'display': 'Private', 'col': 'Private', 'agg': 'uniq', 'format': 'percentFormat2P', 'ag-grid': True, 'pnl-grid': True, minWidth: 78, flex: 1},
            {'display': 'Tail Hedge', 'col': 'Tail Hedge', 'agg': 'uniq', 'format': 'percentFormat2P', 'ag-grid': True, 'hide': true, 'pnl-grid': True, minWidth: 84, flex: 1},
        ]};
}

export const portfolioPerformanceSummaryTopBALService = {
     getPositions
    ,getColumnList
    ,getRowData
    ,getAutoGroupColumnDef
};

function getAutoGroupColumnDef(params) {
    return {
         headerName: 'Period'
        ,field: 'Period'
        ,width: 86
        ,pinned: 'left'
        ,resizable: true
        ,cellRendererParams:  { suppressCount: true } 
       };    
}

function getRowData(params) {
    return getPositions(params);
}

function getPositions(query) {
    const requestOptions = { method: 'POST', headers: { ...userBALService.getAuthHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(query) };
    return fetch(`${config.apiDDSUrl}/spdata`, requestOptions).then(Utils.handleResponse);
}